import React from 'react';
import DepartmentOverviewTopRow from '../portal/DepartmentOverviewTopRow';
import DepartmentWhatsNewCard from '../portal/DepartmentWhatsNewCard';
import DepartmentImplementationCard from '../portal/DepartmentImplementationCard';

const MARKETING_FALLBACK_SCHEDULE_URL = 'https://calendly.com/parker-reignmediagroup';

const MarketingAllTab = () => {
  return (
    <div>
      {/* Community · Roadmap (with current task) · Goals */}
      <DepartmentOverviewTopRow category="marketing" />

      {/* What's New (left) · Implementation Hours (right) */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <DepartmentWhatsNewCard department="marketing" />
        <DepartmentImplementationCard
          department="marketing"
          fallbackScheduleUrl={MARKETING_FALLBACK_SCHEDULE_URL}
        />
      </div>
    </div>
  );
};

export default MarketingAllTab;
